import React, { useState } from 'react';

interface Props {
  onSubmit: (name: string, email: string, message: string) => void;
  onCancel: () => void;
}

/**
 * Formulario de captura para visitantes (sin sesión) que quieren hablar con
 * soporte. Pide nombre, email y la consulta inicial en un mismo paso para que
 * el handoff arranque con un mensaje sustantivo (el server valida min(1) en
 * `handoffRequestSchema.initialMessage`).
 *
 * Para usuarios logueados NO se usa este form: el botón del header dispara
 * `startHandoff` directo con un mensaje por defecto.
 */
const SupportCaptureForm: React.FC<Props> = ({ onSubmit, onCancel }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [err, setErr] = useState<string | null>(null);

  const submit = () => {
    if (!name.trim()) {
      setErr('Ingresá tu nombre');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setErr('Ingresá un email válido');
      return;
    }
    if (!message.trim()) {
      setErr('Contanos brevemente en qué te podemos ayudar');
      return;
    }
    onSubmit(name.trim(), email.trim(), message.trim());
  };

  return (
    <div className="m-3 p-3 bg-paper border border-hairline rounded-lg space-y-2 shadow-card">
      <p className="text-sm text-ink font-medium">
        Para conectarte con el equipo, dejános tus datos y tu consulta.
      </p>
      <input
        className="w-full border border-hairline rounded px-2 py-1.5 text-sm bg-white text-ink placeholder:text-sage/70 focus:outline-none focus:ring-2 focus:ring-forest/20 focus:border-forest"
        placeholder="Tu nombre"
        value={name}
        onChange={(e) => setName(e.target.value)}
        autoFocus
      />
      <input
        className="w-full border border-hairline rounded px-2 py-1.5 text-sm bg-white text-ink placeholder:text-sage/70 focus:outline-none focus:ring-2 focus:ring-forest/20 focus:border-forest"
        placeholder="Tu email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        type="email"
      />
      <textarea
        className="w-full border border-hairline rounded px-2 py-1.5 text-sm bg-white text-ink placeholder:text-sage/70 focus:outline-none focus:ring-2 focus:ring-forest/20 focus:border-forest resize-none"
        placeholder="¿En qué te podemos ayudar?"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={3}
      />
      {err && <p className="text-xs text-danger">{err}</p>}
      <div className="flex gap-2 justify-end pt-1">
        <button
          className="text-sage text-sm px-3 py-1.5 rounded hover:bg-paper-2 transition-colors"
          onClick={onCancel}
        >
          Cancelar
        </button>
        <button
          className="bg-forest text-paper px-4 py-1.5 rounded text-sm font-medium hover:bg-forest-mid transition-colors"
          onClick={submit}
        >
          Iniciar consulta
        </button>
      </div>
    </div>
  );
};

export default SupportCaptureForm;
